"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { BookOpen, FileText, ClipboardList, Globe, Smartphone } from "lucide-react";
export default function OnlineCoursesAndDigitalLearningComingSoon() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const features = [{
    icon: BookOpen,
    title: "Recorded Lessons",
    description: "Access expert-led video content anytime"
  }, {
    icon: FileText,
    title: "Lesson resources and Printables",
    description: "Personalised resources compatible with most exam boards"
  }, {
    icon: ClipboardList,
    title: "Quizzes & Assessments",
    description: "Track your progress with interactive tests and quizzes"
  }, {
    icon: Globe,
    title: "Learning Portal",
    description: "Centralised platform for all your courses (in development)"
  }, {
    icon: Smartphone,
    title: "Mobile App",
    description: "Learn on the go with our dedicated app\xA0(in development)"
  }];
  return <section className="py-20 bg-light-background">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {}
          <div ref={headerRef} className="text-center mb-16 space-y-4">
            <div className={`inline-flex items-center gap-2 mb-4 transition-all duration-[var(--duration-medium)] ${headerVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`} style={{
            transitionDelay: "100ms"
          }}>
              <h2 className="text-4xl md:text-5xl font-display font-bold text-primary">
                Online Courses & Digital Learning
              </h2>
              <Badge variant="secondary" className="bg-secondary text-foreground-secondary font-semibold animate-pulse text-lg px-6 py-3">
                Coming Soon
              </Badge>
            </div>
            <p className={`text-lg text-muted-foreground max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "200ms"
          }}>Experience a revolutionary approach to learning with our comprehensive resources and digital platform. Access expert-led courses, interactive assessments, and personalised learning paths, all designed to help you achieve your child's educational goals. This service is undergoing development and is currently not available.</p>
          </div>

          {}
          <div ref={cardsRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {features.map((feature, i) => {
            const Icon = feature.icon;
            return <Card key={i} data-index={i} className={`border border-border hover:border-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:shadow-medium hover:scale-105 ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
              transitionDelay: `${i * 100}ms`
            }}>
                  <CardContent className="flex flex-col items-center text-center gap-3">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <h3 className="font-display font-semibold text-sm text-foreground">
                      {feature.title}
                    </h3>
                    <p className="text-xs text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes flicker {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }
        .animate-pulse {
          animation: flicker 2s ease-in-out infinite;
        }
      `}</style>
    </section>;
}